import { useMutation } from "urql";

import { CreateLegalDocumentDocument } from "../../../graphql/generated.ts";

export function useCreateLegalDocument() {
  return useMutation(CreateLegalDocumentDocument);
}
